var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4C3.44772 4 3 4.44772 3 5V19C3 19.5523 3.44772 20 4 20H20C20.5523 20 21 19.5523 21 19V8.07317C21 7.52089 20.5523 7.07317 20 7.07317H12.7018C11.8594 7.07317 11.1074 6.54537 10.821 5.75319L10.4257 4.65999C10.2825 4.2639 9.90647 4 9.48529 4H4ZM1 5C1 3.34315 2.34315 2 4 2H9.48529C10.7488 2 11.8769 2.7917 12.3066 3.97997L12.7018 5.07317L20 5.07317C21.6569 5.07317 23 6.41632 23 8.07317V19C23 20.6569 21.6569 22 20 22H4C2.34315 22 1 20.6569 1 19V5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.258bcc328e6cc13d4873398b91730a7e.svg";
export { ForwardRef as ReactComponent };